import styled from 'styled-components';
import { Row, Column } from "components/Layout/Grid";

export const Container = styled(Column).attrs({
  className: "d-block-important mb-4"
})``;

export const ContainerDate = styled(Row).attrs({
  className: "d-block-important align-center mt-1"
})``;

export const Title = styled.p.attrs({
  className: "pp-title-description"
})`
  font-size: 12px !important;
`;

type DateProps = {
  expiredAt: string;
}

export const BadgeDate = styled.span.attrs<DateProps>(({ expiredAt }) => ({
  className: `pp-badges${expiredAt != null
    ? "-danger"
    : ""
    } font-bold`,
  role: "BadgeDate"
}))<DateProps>`
  font-size: 12px !important;
  padding: 7px 9px;
`;

export const TimeExpire = styled.span.attrs<DateProps>(({ expiredAt }) => ({
  className: `pp-color${expiredAt != null
    ? "-danger"
    : ""
    } font-bold`
}))<DateProps>`
  font-size: 12px !important;
`;
